export const resources = {
    en: {
        translation: {
            txt_top100: 'TOP 100',
            txt_my_ranking: 'MY RANKING',
            txt_rank: 'Rank',
            txt_name: 'Name',
            txt_search_challenger: 'Search Challenger',
            txt_no_result: 'No Result Found',
            txt_performance: 'Performance',
            txt_statistics: 'STATISTICS',
            txt_performance_des:
                ' will be available within 24 hour after one trade has been made.',
            txt_statistics_des:
                'Statistics will be available within 24 hour after one trade has been made.',
            txt_cumulative_prf: 'CUMULATIVE PERFORMANCE',

            txt_all_time: 'All Time',
            text_index: 'Index',
            txt_performance_index_title: 'What is Performance Index?',
            txt_performance_index_des_1:
                "In the Bitazza Trading Simulator, the Performance Index standardizes each user's portfolio size to a baseline of 10. This normalization ensures equitable comparison, particularly when users have varying initial portfolio sizes.",
            txt_close: 'Close',
            txt_longest: 'Longest',
            txt_winning_streak: 'winning streak',
            txt_highest_daily: 'Highest daily',
            txt_gain: 'gain',
            txt_volume: 'volume',
            txt_volume_traded: 'Volume traded',
            txt_this_week: 'this week',
            txt_n_trades_last_week: 'Number of trades last week',
            txt_n_trades_last_month: 'Number of trades last month',

            txt_v_crypto_last_week: 'Variety of cryptos traded last week',
            txt_v_crypto_last_month: 'Variety of cryptos trade last month',
            txt_h_v__trade_last_week: 'Highest volume traded coin last week',
            txt_h_v__trade_last_month: 'Highest volume traded coin last month',
            txt_max_exposure_last_week: 'Max exposure to asset last week',
            txt_max_exposure_title: 'Max Exposure to Asset',
            txt_max_exposure_des1:
                'Max exposure to asset is a crucial metric for investors that denotes the highest percentage of a particular asset held within a portfolio. For instance, if an investor holds 50% in BTC, 30% in ETH, and 20% in USDS, their max exposure to asset would be 50%. All negative assets will also be taken into account by taking the absoluate value. The computation of this metric is based on daily snapshots of the portfolio, taken every midnight at 00.00 GMT+7.',
            txt_risk_last_week: 'Risk on last week',
            txt_risk_title: 'Risk On',
            txt_risk_des1:
                "Risk-on is a metric that measures an investor's willingness to take on risk, with a higher percentage indicating a greater tolerance for risk. The formula for calculating risk-on involves subtracting the value of stablecoins in the portfolio from the total portfolio size, and then dividing the result by the total portfolio size. Mathematically, the formula for risk-on is expressed as follows:",
            txt_risk_des2: 'Risk-on = 1 - Remaining Credit / Initial Credit',
            txt_risk_des3:
                'By quantifying the degree of risk an investor is willing to undertake, risk-on can inform investment decisions and aid in portfolio management. As with any investment strategy, risk-on must be approached judiciously, balancing the potential for higher returns with the potential for greater volatility and losses.',
            txt_risk_monthly: 'Risk on monthly',
            txt_average_n_t_per_week: 'Average number of trades per week',
            txt_average_n_t_per_month: 'Average number of trades last month',
            txt_v_crypto_per_week: 'Average variety of cryptos traded per week',
            txt_v_crypto_per_month:
                'Average variety of cryptos traded per month',

            txt_edit_name: 'Edit Profile Name',
            txt_profile_name: 'Profile Name',
            txt_profile_name_des: 'Profile name can only be changed once',
            txt_save: 'Save',
            txt_cancel: 'Cancel',
            txt_trading_simulator: 'TRADING SIMULATOR',
            txt_season: 'SEASON',
            txt_start_in: 'STARTS IN',
            txt_start_des: 'Please stay tuned, many rewards awaits',
            txt_rank_tier: 'RANK TIER',
            txt_rules: 'RULES',
            txt_top_1_challengers: 'Top 3% of challengers',
            txt_top_10_challengers: 'Top 10% of challengers',
            txt_top_25_challengers: 'Top 25% of challengers',
            txt_top_50_challengers: 'Top 50% of challengers',
            txt_top_75_challengers: 'Top 75% of challengers',
            txt_min_pnl30: 'Minimum %PNL 30%',
            txt_min_pnl20: 'Minimum %PNL 20%',
            txt_min_pnl10: 'Minimum %PNL 10%',
            txt_min_pnl0: 'Minimum %PNL 0%',
            txt_no_min_required: 'No minimum %PNL required',
            txt_rules_title: 'RULES AND REGULATIONS',
            txt_rules_1:
                '1. Season Bull/Bear is a Beta season where users are able to practice their trading strategies.',
            txt_rules_2:
                '2. You are granted with an initial credit of 100,000USDS where you are able to buy/long and sell/short any coins available in the market. The amount will be deducted from your credit balance. Examples are shown below.',
            txt_rules_3:
                '3. Every 15 minutes your %PNL will be updated which affects your rank.',
            txt_rules_4:
                '4. You will be awarded a rank within 24 hours after you have made 1 successful trade.',
            txt_rules_5:
                '5.There are 6 different ranks: Bronze, Silver, Gold, Diamond, Master and Grand Master depending on your and other competitor’s %PNL. Ranking criterias are displayed.',
            txt_rules_6:
                '6. Bitazza reserves the right to change the rules and regulations of this event at anytime.',
            txt_rules_exa_buy_title: 'Buy/long example:',
            tx_r_b_des1: 'You buy/long 1 BTC at $30,000. Your assets shows:',
            tx_r_b_des2: '1 BTC (worth 30,000USDS)',
            tx_r_b_des3: 'Total PNL = 0',
            tx_r_b_des4: 'Remaining credit: $70,000 (from an initial $100,000)',
            tx_r_b_des5:
                "If BTC's price increases to $35,000, then your assets now reflects:",
            tx_r_b_des6: 'PNL = 5,000USDS (35,000 - 30,000)',
            txt_rules_exa_sell_title: 'Sell/short example:',
            tx_r_s_des1: 'You sell/short 1 BTC at $30,000. Your asset shows:',
            tx_r_s_des2: 'Remaining credit: $70,000 (from an initial $100,000)',
            tx_r_s_des3:
                "If BTC's price decreases to $25,000, then your assets now reflects:",
            tx_r_s_des4: '-1 BTC (worth -25,000 USDS)',

            text_here: 'HERE',
            txt_overall_pnl: 'OVERALL %PNL',
            txt_higher_than_users: 'Higher than % of users',

            txt_no_rewards_this_season: '* There is no rewards for this',
            txt_view_season_summary: 'View Season NO-RISK Summary',
            txt_view: 'View',
            txt_summary: 'Summary',
            txt_claim_nft: 'Claim NFT Reward',
            text_share: 'Share',
            txt_n_of: 'NO. OF',
            txt_challenger: 'CHALLENGER',
            txt_average: 'AVERAGE',
            txt_top_challengers: 'TOP CHALLENGERS',
            txt_joining_fee: 'JOINING FEE',
            txt_limited_time: '* Limited time. Join now!',
            txt_free: 'FREE',
            txt_join_btn: 'Join Trading Simulator',
            txt_calc_rewards: 'CALCULATING REWARDS',
            txt_calc_rewards_des:
                'Your rewards are being calculated, this should take less than 72 hours.',
            txt_prize_pool: 'PRIZE POOL ALLOCATION',
            txt_prize_allocation: '% Prize Pool Allocation',
            txt_btz_awarded: 'BTZ Amount Awarded',
            txt_usdt_awarded: 'FDS Amount Awarded',

            txt_profile_Special: 'Please do not use special characters.',
            txt_profile_char: 'Profile name must be between 2 - 8 characters.',
            txt_profile_impolite: 'Please do not use rude or impolite words.',
            txt_wins_refers:
                "In Trading Simulator, a 'win' refers to a day where a gain is made in the portfolio's overall value. The longest winning streak is a metric that tracks the highest number of consecutive days in which gains have been made in the portfolio's overall value.",
            txt_your_ranking: 'Your ranking is N/A since you have',
            txt_join_later: 'joined later than threshold date for a rank',
            txt_max_50: 'Max 50 challengers',
            txt_days: 'days',
            txt_hours: 'hours',
            txt_minutes: 'minutes',
            txt_sec: 'seconds',
            txt_below_avr: 'Below average',
            txt_higher_than: 'Higher than',
            txt_of_users: 'of users',
            txt_of_trader: 'of traders',
            txt_of_bronze: 'of users with a Bronze badge',
            txt_badge_note: 'Note: Badges are updated daily at 00.00 GMT+7 ',
            txt_more_trade_1: 'You need to make',
            txt_more_trade_2:
                'more trades to be eligible inside the leaderboard',
            txt_more_trade_3:
                'more trade to be eligible inside the leaderboard',
            text_total_prize: 'TOTAL PRIZE POOL',

            txt_max_prize_pool: 'MAX PRIZE POOL',
            txt_prize_pool_des:
                'Prize pool increases with number of challengers',
            txt_prize_pool_view: 'View Prize Pool Details',
        },
    },

    cn: {
        translation: {
            txt_top100: '前100名',
            txt_my_ranking: '我的排名',
            txt_rank: '排名',
            txt_name: '名称',
            txt_search_challenger: '搜索挑战者',
            txt_no_result: '未找到结果',
            txt_performance: '表现',
            txt_statistics: '统计数据',
            txt_performance_des: '交易完成后24小时内将提供性能。',
            txt_statistics_des: '统计数据',
            txt_cumulative_prf: '累积绩效',

            txt_all_time: '所有时间',
            text_index: '指数',
            txt_performance_index_title: '什么是绩效指数？',
            txt_performance_index_des_1:
                '在Bitazza交易模拟器中，绩效指数将每个用户的投资组合大小标准化为10的基线。这种标准化确保公平比较，尤其是当用户的初始投资组合大小各不相同时。',
            txt_close: '关闭',
            txt_longest: '最长的',
            txt_winning_streak: '连胜',
            txt_highest_daily: '日最大收益',
            txt_gain: '量',
            txt_volume: '本周交易量',
            txt_volume_traded: '上周交易次数',
            txt_this_week: '本周',
            txt_n_trades_last_week: '上周交易次数',
            txt_n_trades_last_month: '上个月的交易次数',

            txt_v_crypto_last_week: '上周交易的加密货币种类',
            txt_v_crypto_last_month: '上个月交易的加密货币种类',
            txt_h_v__trade_last_week: '上周交易量最高的货币',
            txt_h_v__trade_last_month: '上个月交易量最高的货币',
            txt_max_exposure_last_week: '上周最大接触资产',
            txt_max_exposure_title: '对资产的最大曝露',
            txt_max_exposure_des1:
                '最大资产敞口是投资者的一个关键指标，它表示投资组合中持有的特定资产的最高百分比。例如，如果投资者在BTC中持有50%，在ETH中持有30%，在USDS中持有20%，那么他们的最大资产敞口将是50%。所有负资产也将通过取绝对值来计算在内。此指标的计算是基于投资组合的每日快照，每天午夜00.00 GMT+7拍摄。',
            txt_risk_last_week: '上周的风险',
            txt_risk_title: '风险开启',
            txt_risk_des1:
                '风险登机是一个指标，可以衡量投资者承担风险的意愿，较高的百分比表明对风险的容忍度更高。计算风险的公式涉及从总投资组合大小中减去投资组合中的Stablecoins的值，然后将结果除以总投资组合大小。从数学上讲，风险的公式表示如下：',
            txt_risk_des2: '风险 -  = 1-剩余的信用 /初始信用',
            txt_risk_des3:
                '通过量化投资者愿意承担的风险，风险可以为投资决策提供信息并帮助投资组合管理。与任何投资策略一样，必须先明智地接触风险，使更高回报的潜力与更大的波动性和损失的潜力保持平衡。',
            txt_risk_monthly: '每月冒险',
            txt_average_n_t_per_week: '平均每周交易数量',
            txt_average_n_t_per_month: '上个月的平均交易数量',
            txt_v_crypto_per_week: '平均每周交易的加密货币种类',

            txt_v_crypto_per_month: '平均每月交易的加密货币种类',
            txt_edit_name: '编辑个人资料名称',
            txt_profile_name: '配置文件名称',
            txt_profile_name_des: '个人资料名称只能更改一次',
            txt_save: '节省',
            txt_cancel: '取消',
            txt_trading_simulator: '交易模拟器',
            txt_season: '季节',
            txt_start_in: '开始',
            txt_start_des: '请继续关注并准备好等待的奖励',
            txt_rank_tier: '等级',
            txt_rules: '规则',
            txt_top_1_challengers: '挑战者的最高3％',
            txt_top_10_challengers: '挑战者的最高10％',
            txt_top_25_challengers: '挑战者的最高25％',
            txt_top_50_challengers: '挑战者的最高50％',
            txt_top_75_challengers: '挑战者的最高75％',
            txt_min_pnl30: '最低％pnl 30％',
            txt_min_pnl20: '最低％pnl 20％',
            txt_min_pnl10: '最低％pnl 10％',
            txt_min_pnl0: '最低％pnl 0％',

            txt_no_min_required: '无需最低％PNL',
            txt_rules_title: '条款和规则',
            txt_rules_1: '1.季节牛/熊是一个beta季节，用户能够练习其交易策略。',
            txt_rules_2:
                '2.您获得了100,000名的初始信用，您可以在市场上购买/长时间出售/卖空任何硬币。该金额将从您的信用余额中扣除。示例如下所示。',
            txt_rules_3: '3.每15分钟，您的％pnl将更新，从而影响您的排名。',
            txt_rules_4: '4.完成1个成功交易后的24小时内，您将获得排名。',
            txt_rules_5:
                '5，有6个不同的等级：铜，银，金，钻石，大师和大师，具体取决于您和其他竞争对手的％PNL。显示排名标准。',
            txt_rules_6: '6. Bitazza保留随时更改此事件规则和规定的权利。',
            txt_rules_exa_buy_title: '购买/漫长的例子',
            tx_r_b_des1: '您以30,000美元的价格购买/长1 BTC。您的资产显示',
            tx_r_b_des2: '1 BTC（价值30,000名）',
            tx_r_b_des3: '总PNL = 0',
            tx_r_b_des4: '剩余的信贷：70,000美元（从最初的100,000美元起）',
            tx_r_b_des5:
                '如果BTC的价格上涨至35,000美元，那么您的资产现在可以反映',
            tx_r_b_des6: 'PNL = 5,000个（35,000-30,000）',
            txt_rules_exa_sell_title: '出售/简短例子',
            tx_r_s_des1: '您以30,000美元的价格出售/简短1 BTC。您的资产显示',
            tx_r_s_des2: '剩余的信贷：70,000美元（从最初的100,000美元起）',
            tx_r_s_des3:
                '如果BTC的价格降至25,000美元，那么您的资产现在可以反映',
            text_here: '这里',
            txt_overall_pnl: '总体％pnl',
            txt_higher_than_users: '高于用户的百分比',

            txt_no_rewards_this_season: '*这个Beta赛季没有奖励',
            txt_view_season_summary: '查看季节无风险摘要',
            txt_view: '查看',
            txt_summary: '概要',
            txt_claim_nft: 'Claim NFT Reward',
            text_share: 'Share',
            txt_n_of: '不。的',
            txt_challenger: '挑战者',
            txt_average: '平均的',
            txt_top_challengers: '顶级挑战者',
            txt_joining_fee: '加盟费用',
            txt_limited_time: '* 有限的时间。立即加入！',
            txt_free: '自由的',
            txt_join_btn: '加入交易模拟器',
            txt_calc_rewards: '计算奖励',
            txt_calc_rewards_des: '您正在计算您的奖励，这应该花费2个小时。',
            txt_prize_pool: '奖励池分配',
            txt_prize_allocation: '％奖金分配',
            txt_btz_awarded: '授予BTZ金额',
            txt_usdt_awarded: '授予FDS金额',

            txt_profile_Special: '请不要使用特殊字符。',
            txt_profile_char: '档案名称必须在2-8个字符之间。',
            txt_profile_impolite: '请不要使用粗鲁或不礼貌的话语。',
            txt_wins_refers:
                "在交易模拟器中，'赢'指的是投资组合整体价值增加的一天。",
            txt_your_ranking:
                '最长的连胜纪录是一个指标，跟踪连续几天内投资组合整体价值已经获得的最高收益。',
            txt_join_later: '比设定的排名日期晚加入',
            txt_max_50: '最多50个挑战者',
            txt_days: '天',
            txt_hours: '小时',
            txt_minutes: '分钟',
            txt_sec: ' 秒',

            txt_below_avr: '低于平均水平',
            txt_higher_than: '高于',
            txt_of_users: '的用户',
            txt_of_trader: '的交易员',
            txt_of_bronze: '拥有青铜徽章的用户',
            txt_badge_note: '注：徽章每天在GMT+7的00.00更新 ',
            txt_more_trade_1: '你需要做',
            txt_more_trade_2: '进行更多交易才有资格进入排行榜',
            txt_more_trade_3: '进行更多交易才有资格进入排行榜',
            text_total_prize: '总奖池',
            txt_max_prize_pool: '最大奖池',
            txt_prize_pool_des: '随着挑战者数量的增加奖池增加',
            txt_prize_pool_view: '查看奖池分配',
        },
    },

    es: {
        translation: {
            txt_top100: 'TOP 100',
            txt_my_ranking: 'MI RANKING',
            txt_rank: 'Rango',
            txt_name: 'Nombre',
            txt_search_challenger: 'Buscar retador',
            txt_no_result: 'No se encontraron resultados',
            txt_performance: 'Rendimiento',
            txt_statistics: 'ESTADÍSTICAS',
            txt_performance_des:
                'El rendimiento estará disponible en 24 horas después de haber realizado una operación.',
            txt_statistics_des: 'ESTADÍSTICAS',
            txt_cumulative_prf: 'RENDIMIENTO ACUMULADO',

            txt_all_time: 'Todo el tiempo',
            text_index: 'índice',
            txt_performance_index_title: '¿Qué es el Índice de Rendimiento?',
            txt_performance_index_des_1:
                'En el Simulador de Trading de Bitazza, el Índice de Rendimiento estandariza el tamaño del portafolio de cada usuario a una línea base de 10. Esta normalización asegura una comparación equitativa, especialmente cuando los usuarios tienen tamaños iniciales de portafolio variados.',
            txt_close: 'cerrar',
            txt_longest: 'Más largo',
            txt_winning_streak: 'racha de victorias',
            txt_highest_daily: 'Ganancia diaria más alta',
            txt_gain: 'volumen',
            txt_volume: 'Volumen',
            txt_volume_traded: 'Número de operaciones',
            txt_this_week: 'esta semana',
            txt_n_trades_last_week: 'Número de operaciones la semana pasada',
            txt_n_trades_last_month: 'Número de operaciones el mes pasado',

            txt_v_crypto_last_week:
                ' Variedad de criptomonedas operadas la semana pasada',
            txt_v_crypto_last_month:
                'Variedad de criptomonedas operadas el mes pasado',
            txt_h_v__trade_last_week:
                'Moneda con mayor volumen de transacciones la semana pasada',
            txt_h_v__trade_last_month:
                'Moneda con mayor volumen de transacciones el mes pasado',
            txt_max_exposure_last_week:
                ' Exposición máxima al activo la semana pasada',
            txt_max_exposure_title: 'Exposición máxima al activo',
            txt_max_exposure_des1:
                'La máxima exposición a un activo es una métrica crucial para los inversores que denota el porcentaje más alto de un activo particular mantenido dentro de una cartera. Por ejemplo, si un inversor tiene el 50% en BTC, el 30% en ETH, y el 20% en USDS, su máxima exposición al activo sería del 50%. También se tendrán en cuenta todos los activos negativos tomando el valor absoluto. El cálculo de esta métrica se basa en instantáneas diarias de la cartera, tomadas cada medianoche a las 00.00 GMT+7.',
            txt_risk_last_week: 'Riesgo de la semana pasada',
            txt_risk_title: 'Riesgo Activo',
            txt_risk_des1:
                'El riesgo es una métrica que mide la voluntad de un inversor para asumir el riesgo, con un mayor porcentaje que indica una mayor tolerancia al riesgo. La fórmula para calcular el riesgo implica restar el valor de las establo en la cartera del tamaño total de la cartera, y luego dividir el resultado por el tamaño total de la cartera. Matemáticamente, la fórmula para el riesgo se expresa de la siguiente manera:',
            txt_risk_des2: 'Risk -On = 1 - Crédito restante / Crédito inicial',
            txt_risk_des3:
                'Al cuantificar el grado de riesgo que un inversor está dispuesto a emprender, el riesgo puede informar las decisiones de inversión y ayudar en la gestión de la cartera. Al igual que con cualquier estrategia de inversión, el riesgo debe abordarse juiciosamente, equilibrando el potencial de mayores rendimientos con el potencial de una mayor volatilidad y pérdidas.',
            txt_risk_monthly: 'Riesgo en mensual',
            txt_average_n_t_per_week:
                'Número promedio de operaciones por semana',
            txt_average_n_t_per_month:
                'Número promedio de operaciones el mes pasado',
            txt_v_crypto_per_week:
                'Variedad promedio de criptos negociados por semana',

            txt_v_crypto_per_month:
                'Variedad promedio de criptos negociados por mes',
            txt_edit_name: 'Editar nombre de perfil',
            txt_profile_name: 'Nombre de perfil',
            txt_profile_name_des:
                'El nombre del perfil solo se puede cambiar una vez',
            txt_save: 'ahorrar',
            txt_cancel: 'Cancelar',
            txt_trading_simulator: 'Simulador de comercio',
            txt_season: 'ESTACIÓN',
            txt_start_in: 'EMPEZAR EN',
            txt_start_des: 'Estén atentos y prepárate las recompensas esperan',
            txt_rank_tier: 'Nivel de rango',
            txt_rules: 'NORMAS',
            txt_top_1_challengers: 'El 3% superior de los retadores',
            txt_top_10_challengers: 'El 10% superior de los retadores',
            txt_top_25_challengers: 'El 25% superior de los retadores',
            txt_top_50_challengers: 'El 50% superior de los retadores',
            txt_top_75_challengers: 'El 75% superior de los retadores',
            txt_min_pnl30: 'Mínimo %PNL 30 %',
            txt_min_pnl20: 'Mínimo %PNL 20 %',
            txt_min_pnl10: 'Mínimo %PNL 10 %',
            txt_min_pnl0: 'Mínimo %PNL 0 %',

            txt_no_min_required: 'No se requiere un mínimo %PNL',
            txt_rules_title: 'REGLAS Y REGULACIONES',
            txt_rules_1:
                '1. Season Bull/Bear es una temporada beta donde los usuarios pueden practicar sus estrategias comerciales.',
            txt_rules_2:
                '2. Se le otorga un crédito inicial de 100,000 usos en los que puede comprar/largos y vender/corto cualquier monedas disponibles en el mercado. El monto se deducirá de su saldo de crédito. Los ejemplos se muestran a continuación.',
            txt_rules_3:
                '3. Cada 15 minutos se actualizará su %PNL, lo que afecta su rango.',
            txt_rules_4:
                '4. Se le otorgará un rango dentro de las 24 horas posteriores a haber realizado 1 intercambio exitoso.',
            txt_rules_5:
                '5. Hay 6 rangos diferentes: bronce, plata, oro, diamante, maestro y gran maestro, dependiendo de su %PNL de otros competidores. Se muestran criterios de clasificación.',
            txt_rules_6:
                '6. Bitazza se reserva el derecho de cambiar las reglas y regulaciones de este evento en cualquier momento.',
            txt_rules_exa_buy_title: 'Comprar/Ejemplo largo',
            tx_r_b_des1:
                'Compras/largo 1 BTC a $ 30,000. Tus espectáculos de activos',
            tx_r_b_des2: '1 BTC (por valor de 30,000 usos)',
            tx_r_b_des3: 'PNL total = 0',
            tx_r_b_des4:
                'Crédito restante: $ 70,000 (desde $ 100,000 iniciales)',
            tx_r_b_des5:
                'Si el precio de BTC aumenta a $ 35,000, entonces sus activos ahora se reflejan',
            tx_r_b_des6: 'PNL = 5,000个（35,000-30,000）',
            txt_rules_exa_sell_title: 'Vender/Ejemplo corto',
            tx_r_s_des1:
                'Usted vende/corto 1 BTC a $ 30,000. Tus espectáculos de activos',
            tx_r_s_des2:
                'Crédito restante: $ 70,000 (desde $ 100,000 iniciales)',
            tx_r_s_des3:
                'Si el precio de BTC disminuye a $ 25,000, entonces sus activos ahora reflejan',
            text_here: 'aquí',
            txt_overall_pnl: '% %PNL',
            txt_higher_than_users: 'Más alto del % de usuarios',

            txt_no_rewards_this_season:
                '* No hay recompensas para esta temporada beta',

            txt_view: 'Ver',
            txt_summary: 'Resumen',
            txt_claim_nft: 'Claim NFT Reward',
            text_share: 'Share',
            txt_view_season_summary: 'Ver Resumen de la temporada sin riesgo',
            txt_n_of: 'NO. DE',
            txt_challenger: 'DESAFIADOR',
            txt_average: 'PROMEDIO',
            txt_top_challengers: 'Los mejores retadores',
            txt_joining_fee: 'CUOTA DE INSCRIPCIÓN',
            txt_limited_time: '* Tiempo limitado. ¡Únete ahora!',
            txt_free: 'GRATIS',
            txt_join_btn: 'Unirse al simulador de comercio',
            txt_calc_rewards: 'Recompensas calculadoras',
            txt_calc_rewards_des:
                'Se están calculando sus recompensas, esto debería tomar menos de 2 horas.',
            txt_prize_pool: 'Asignación de la piscina de premios',
            txt_prize_allocation: '% De asignación de premios de premios',
            txt_btz_awarded: 'Cantidad de BTZ otorgada',
            txt_usdt_awarded: 'Cantidad de FDS otorgada',

            txt_profile_Special: 'Por favor, no uses caracteres especiales.',
            txt_profile_char:
                'El nombre del perfil debe tener entre 2-8 caracteres.',
            txt_profile_impolite:
                'Por favor, no uses palabras groseras o impolitas.',
            txt_wins_refers:
                "En el Simulador de Trading, una 'victoria' se refiere a un día en el que se ha obtenido una ganancia en el valor total de la cartera.",
            txt_your_ranking:
                'La racha de victorias más larga es una métrica que sigue el mayor número de días consecutivos en los que se han obtenido ganancias en el valor total de la cartera.',
            txt_join_later: 'se unió después de la fecha límite para un rango',
            txt_max_50: 'Máximo 50 competidores',
            txt_days: 'días',
            txt_hours: 'horas',
            txt_minutes: 'minutos',
            txt_sec: ' segundos',

            txt_below_avr: 'Por debajo de la media',
            txt_higher_than: 'Más alto que',
            txt_of_users: 'de usuarios',
            txt_of_trader: 'de comerciantes',
            txt_of_bronze: 'de usuarios con una insignia Bronce',
            txt_badge_note:
                'Nota: Las insignias se actualizan diariamente a las 00.00 GMT+7',
            txt_more_trade_1: 'Necesitas hacer',
            txt_more_trade_2:
                'más operaciones para ser elegible en la clasificación',
            txt_more_trade_3:
                'más operaciones para ser elegible en la clasificación',
            text_total_prize: 'POZO DE PREMIOS TOTAL',
            txt_max_prize_pool: 'PREMIO MÁXIMO',
            txt_prize_pool_des: 'El premio aumenta con el número de retadores',
            txt_prize_pool_view: 'Ver distribución del premio',
        },
    },

    id: {
        translation: {
            txt_top100: 'TOP 100',
            txt_my_ranking: 'PERINGKAT SAYA',
            txt_rank: 'Peringkat',
            txt_name: 'Nama',
            txt_search_challenger: 'Cari Penantang',
            txt_no_result: 'Tidak Ada Hasil Ditemukan',
            txt_performance: 'Kinerja',
            txt_statistics: 'STATISTIK',
            txt_performance_des:
                'Kinerja akan tersedia dalam 24 jam setelah satu perdagangan telah dilakukan.',
            txt_statistics_des: 'Statistik',
            txt_cumulative_prf: 'KINERJA KUMULATIF',

            txt_all_time: 'Sepanjang Waktu',
            text_index: 'indeks',
            txt_performance_index_title: 'Apa itu Indeks Kinerja?',
            txt_performance_index_des_1:
                'Dalam Bitazza Trading Simulator, Indeks Kinerja menstandarisasi ukuran portofolio setiap pengguna ke basis 10. Normalisasi ini memastikan perbandingan yang adil, khususnya saat pengguna memiliki ukuran portofolio awal yang berbeda.',
            txt_close: 'tutup',
            txt_longest: 'Terpanjang',
            txt_winning_streak: 'kemenangan beruntun',
            txt_highest_daily: 'Keuntungan harian tertinggi',
            txt_gain: 'volume',
            txt_volume: 'Volume',
            txt_volume_traded: 'Jumlah transaksi',
            txt_this_week: 'minggu ini',
            txt_n_trades_last_week: 'Jumlah transaksi minggu lalu',
            txt_n_trades_last_month: 'Jumlah transaksi bulan lalu',

            txt_v_crypto_last_week:
                'Ragam kripto yang diperdagangkan minggu lalu',
            txt_v_crypto_last_month:
                'Ragam kripto yang diperdagangkan bulan lalu',
            txt_h_v__trade_last_week:
                'Koin dengan volume tertinggi yang diperdagangkan minggu lalu',
            txt_h_v__trade_last_month:
                'Koin dengan volume tertinggi yang diperdagangkan bulan lalu',
            txt_max_exposure_last_week: 'Paparan aset maksimal minggu lalu',
            txt_max_exposure_title: 'Pemaparan maksimal ke aset',
            txt_max_exposure_des1:
                'Pemaparan maksimal terhadap aset adalah metrik penting bagi investor yang menunjukkan persentase tertinggi dari aset tertentu yang dipegang dalam portofolio. Misalnya, jika seorang investor memiliki 50% di BTC, 30% di ETH, dan 20% di USDS, paparan maksimal mereka terhadap aset akan menjadi 50%. Semua aset negatif juga akan diperhitungkan dengan mengambil nilai absolut. Perhitungan metrik ini didasarkan pada gambaran harian dari portofolio, yang diambil setiap tengah malam pada 00.00 GMT+7.',
            txt_risk_last_week: 'Risiko minggu lalu',
            txt_risk_title: 'Risiko Aktif',
            txt_risk_des1:
                'Risiko adalah metrik yang mengukur kemauan investor untuk mengambil risiko, dengan persentase yang lebih tinggi menunjukkan toleransi yang lebih besar terhadap risiko. Rumus untuk menghitung risiko-on melibatkan pengurangan nilai stablecoin dalam portofolio dari total ukuran portofolio, dan kemudian membagi hasil dengan ukuran portofolio total. Secara matematis, rumus untuk risiko dinyatakan sebagai berikut:',
            txt_risk_des2: 'Risiko -on = 1 - Kredit / Kredit Awal yang Tersisa',
            txt_risk_des3:
                'Dengan mengukur tingkat risiko yang bersedia dilakukan investor, risiko dapat menginformasikan keputusan investasi dan bantuan dalam manajemen portofolio. Seperti halnya strategi investasi apa pun, risiko-on harus didekati dengan bijaksana, menyeimbangkan potensi pengembalian yang lebih tinggi dengan potensi volatilitas dan kerugian yang lebih besar.',
            txt_risk_monthly: 'Risiko di bulan',
            txt_average_n_t_per_week:
                'Jumlah rata -rata perdagangan per minggu',
            txt_average_n_t_per_month:
                'Jumlah rata -rata perdagangan bulan lalu',
            txt_v_crypto_per_week:
                'Variasi rata -rata cryptos diperdagangkan per minggu',
            txt_v_crypto_per_month:
                'Rata -rata variasi cryptos yang diperdagangkan per bulan',
            txt_edit_name: 'Edit Nama Profil',
            txt_profile_name: 'Nama profil',
            txt_profile_name_des: 'Nama profil hanya dapat diubah sekali',
            txt_save: 'menyimpan',
            txt_cancel: 'membatalkan',
            txt_trading_simulator: 'Simulator perdagangan',
            txt_season: 'MUSIM',
            txt_start_in: 'Mulai',
            txt_start_des:
                'Tetap disini dan bersiaplah dengan imbalan menunggu',
            txt_rank_tier: 'Tingkat peringkat',
            txt_rules: 'ATURAN',
            txt_top_1_challengers: '3% penantang teratas',
            txt_top_10_challengers: '10% penantang teratas',
            txt_top_25_challengers: '25% penantang teratas',
            txt_top_50_challengers: '50% penantang teratas',
            txt_top_75_challengers: '75% penantang teratas',
            txt_min_pnl30: 'Minimum %PNL 30 %',
            txt_min_pnl20: 'Minimum %PNL 20 %',
            txt_min_pnl10: 'Minimum %PNL 10 %',
            txt_min_pnl0: 'Minimum %PNL 0 %',

            txt_no_min_required: 'Tidak ada %PNL minimum yang diperlukanL',
            txt_rules_title: 'Tidak ada %PNL minimum yang diperlukan',
            txt_rules_1:
                '1. Musim Bull/Bear adalah musim beta di mana pengguna dapat mempraktikkan strategi perdagangan mereka.',
            txt_rules_2:
                '2. Anda diberikan dengan kredit awal 100.000SD di mana Anda dapat membeli/panjang dan menjual/pendek koin apa pun yang tersedia di pasar. Jumlahnya akan dikurangkan dari saldo kredit Anda. Contoh ditunjukkan di bawah ini.',
            txt_rules_3:
                '3. Setiap 15 menit %PNL Anda akan diperbarui yang memengaruhi peringkat Anda.',
            txt_rules_4:
                '4. Anda akan diberikan peringkat dalam waktu 24 jam setelah Anda melakukan 1 perdagangan yang sukses.',
            txt_rules_5:
                '5. Ada 6 peringkat yang berbeda: perunggu, perak, emas, berlian, master dan grand master tergantung pada %PNL pesaing Anda dan pesaing lainnya. Kriteria peringkat ditampilkan.',
            txt_rules_6:
                '6. Bitazza berhak untuk mengubah aturan dan peraturan acara ini kapan saja.',
            txt_rules_exa_buy_title: 'Beli/Contoh Panjang',
            tx_r_b_des1:
                'Anda membeli/panjang 1 BTC dengan harga $ 30.000. Aset Anda menunjukkan',
            tx_r_b_des2: '1 BTC (senilai 30.000SUSD)',
            tx_r_b_des3: 'Total PNL = 0',
            tx_r_b_des4: 'Kredit yang tersisa: $ 70.000 (dari $ 100.000 awal)',
            tx_r_b_des5:
                'Jika harga BTC naik menjadi $ 35.000, maka aset Anda sekarang mencerminkan',
            tx_r_b_des6: 'PNL = 5.000USDS (35.000 - 30.000)',
            txt_rules_exa_sell_title: 'Jual/Contoh Singkat',
            tx_r_s_des1:
                'Anda menjual/pendek 1 BTC seharga $ 30.000. Pertunjukan aset Anda',
            tx_r_s_des2: 'Kredit yang tersisa: $ 70.000 (dari $ 100.000 awal)',
            tx_r_s_des3:
                'Jika harga BTC turun menjadi $ 25.000, maka aset Anda sekarang mencerminkan',
            text_here: 'Di Sini',
            txt_overall_pnl: 'Secara keseluruhan %PNL',
            txt_higher_than_users: 'Lebih tinggi dari % pengguna',

            txt_no_rewards_this_season:
                '* Tidak ada hadiah untuk musim beta ini',
            txt_view_season_summary: 'Lihat Ringkasan Musim Tidak Risiko',

            txt_view: 'Lihat',
            txt_summary: 'Ringkasan',
            txt_claim_nft: 'Claim NFT Reward',
            text_share: 'Share',
            txt_n_of: 'TIDAK. DARI',
            txt_challenger: 'PENANTANG',
            txt_average: 'RATA-RATA',
            txt_top_challengers: 'Penantang teratas',
            txt_joining_fee: 'Biaya bergabung',
            txt_limited_time: '* Waktu terbatas. Bergabung sekarang!',
            txt_free: 'BEBAS',
            txt_join_btn: 'Bergabunglah dengan simulator perdagangan',
            txt_calc_rewards: 'Menghitung imbalan',
            txt_calc_rewards_des:
                'Imbalan Anda sedang dihitung, ini akan memakan waktu kurang dari 2 jam.',
            txt_prize_pool: 'Alokasi Kolam Hadiah',
            txt_prize_allocation: '% Alokasi Hadiah Kolam Hadiah',
            txt_btz_awarded: 'Jumlah BTZ yang diberikan',
            txt_usdt_awarded: 'Jumlah FDS yang diberikan',

            txt_profile_Special: 'Tolong jangan gunakan karakter khusus.',
            txt_profile_char: 'Nama profil harus antara 2-8 karakter.',
            txt_profile_impolite:
                'Tolong jangan gunakan kata-kata yang kasar atau tidak sopan.',
            txt_wins_refers:
                "Dalam Simulator Trading, 'menang' mengacu pada hari di mana ada keuntungan pada nilai keseluruhan portofolio.",
            txt_your_ranking:
                'Urutan kemenangan terpanjang adalah metrik yang melacak jumlah hari berturut-turut tertinggi di mana keuntungan telah dibuat dalam nilai keseluruhan portofolio.',
            txt_join_later: 'bergabung setelah tanggal batas untuk peringkat',
            txt_max_50: 'Maksimal 50 pesaing',
            txt_days: 'hari',
            txt_hours: 'jam',
            txt_minutes: 'menit',
            txt_sec: 'detik',

            txt_below_avr: 'Dibawah rata-rata',
            txt_higher_than: 'Lebih tinggi dari',
            txt_of_users: 'dari pengguna',
            txt_of_trader: 'dari pedagang',
            txt_of_bronze: 'dari pengguna dengan lencana Perunggu',
            txt_badge_note:
                'Catatan: Lencana diperbarui setiap hari pukul 00.00 GMT+7',
            txt_more_trade_1: 'Anda perlu melakukan',
            txt_more_trade_2:
                'perdagangan lebih lanjut untuk memenuhi syarat di dalam papan peringkat',
            txt_more_trade_3:
                'perdagangan lebih lanjut untuk memenuhi syarat di dalam papan peringkat',
            text_total_prize: 'HADIAH TOTAL',
            txt_max_prize_pool: 'HADIAH MAKSIMUM',
            txt_prize_pool_des: 'Hadiah meningkat dengan jumlah pesaing',
            txt_prize_pool_view: 'Lihat Alokasi Hadiah',
        },
    },

    kr: {
        translation: {
            txt_top100: 'TOP 100',
            txt_my_ranking: '나의 순위',
            txt_rank: '순위',
            txt_name: '이름',
            txt_search_challenger: '도전자 검색',
            txt_no_result: '결과를 찾을 수 없습니다',
            txt_performance: '성능',
            txt_statistics: '통계',
            txt_performance_des: '거래 후 24시간 내에 성능이 제공됩니다.',
            txt_statistics_des: '통계',
            txt_cumulative_prf: '누적 성능',

            txt_all_time: ' 모든 시간',
            text_index: '지수',
            txt_performance_index_title: '성과 지수란 무엇입니까?',
            txt_performance_index_des_1:
                'Bitazza 거래 시뮬레이터에서 성과 지수는 각 사용자의 포트폴리오 크기를 10의 기준선으로 표준화합니다. 이 정규화는 사용자의 초기 포트폴리오 크기가 다양할 때 특히 공정한 비교를 보장합니다.',
            txt_close: '닫기',
            txt_longest: '가장 긴',
            txt_winning_streak: '연속 승리',
            txt_highest_daily: '일일 최대 이익',
            txt_gain: '볼륨',
            txt_volume: '이번 주 거래량',
            txt_volume_traded: '지난 주 거래 횟수',
            txt_this_week: '이번 주',
            txt_n_trades_last_week: '지난 주 거래 횟수',
            txt_n_trades_last_month: '지난 달 거래 횟수',

            txt_v_crypto_last_week: '지난 주에 거래된 암호화폐 종류',
            txt_v_crypto_last_month: ' 지난 달에 거래된 암호화폐 종류',
            txt_h_v__trade_last_week: '지난 주 거래량이 가장 높은 코인',
            txt_h_v__trade_last_month: '지난 달 거래량이 가장 높은 코인',
            txt_max_exposure_last_week: '지난주 자산에 대한 최대 노출',
            txt_max_exposure_title: '자산에 대한 최대 노출',
            txt_max_exposure_des1:
                '자산에 대한 최대 노출은 포트폴리오 내에서 특정 자산의 최대 비율을 나타내는 투자자에게 중요한 지표입니다. 예를 들어, 투자자가 BTC에서 50%, ETH에서 30%, USDS에서 20%를 보유하면 그들의 자산에 대한 최대 노출은 50%가 될 것입니다. 모든 부정 자산도 절대값을 취하여 계산됩니다. 이 지표의 계산은 포트폴리오의 매일 자정 00.00 GMT+7에 찍힌 스냅샷에 기반합니다.',
            txt_risk_last_week: '지난 주의 위험',
            txt_risk_title: '위험 수용',
            txt_risk_des1:
                'Risk-on은 투자자의 위험을 감수하려는 의지를 측정하는 지표이며, 높은 비율은 위험에 대한 더 큰 내성을 나타냅니다. 위험을 계산하기위한 공식에는 총 포트폴리오 크기에서 포트폴리오에서 stablecoin의 가치를 빼낸 다음 결과를 총 포트폴리오 크기로 나누는 것입니다. 수학적으로, 위험에 대한 공식은 다음과 같이 표현됩니다.',
            txt_risk_des2: 'Risk -on = 1- 나머지 신용 / 초기 크레딧',
            txt_risk_des3:
                '투자자가 기꺼이 수행하고자하는 위험의 정도를 정량화함으로써 Risk-on은 투자 결정에 정보를 제공하고 포트폴리오 관리를 도울 수 있습니다. 모든 투자 전략과 마찬가지로 위험 온은 신중하게 접근해야하며, 더 높은 수익률의 잠재력을 더 큰 변동성과 손실의 가능성과 균형을 맞추어야합니다.',
            txt_risk_monthly: '월별 위험',
            txt_average_n_t_per_week: '주당 평균 거래 수',
            txt_average_n_t_per_month: '지난 달 평균 거래 수',
            txt_v_crypto_per_week: '일주일에 평균 암호화가 거래됩니다',

            txt_v_crypto_per_month: '한 달에 평균 암호화 거래',
            txt_edit_name: '프로필 이름 편집',
            txt_profile_name: '프로필 이름',
            txt_profile_name_des: '프로필 이름은 한 번만 변경할 수 있습니다',
            txt_save: '구하다',
            txt_cancel: '취소',
            txt_trading_simulator: '거래 시뮬레이터',
            txt_season: '계절',
            txt_start_in: '에서 시작',
            txt_start_des: '계속 지켜봐 주시고 보상을 기다리고 있습니다',
            txt_rank_tier: '계층 순위',
            txt_rules: '규칙',
            txt_top_1_challengers: '도전자의 상위 3%',
            txt_top_10_challengers: '도전자의 상위 10%',
            txt_top_25_challengers: '도전자의 상위 25%',
            txt_top_50_challengers: '도전자의 상위 50%',
            txt_top_75_challengers: '도전자의 상위 75%',

            txt_min_pnl30: '최소 %PNL 30 %',
            txt_min_pnl20: '최소 %PNL 20 %',
            txt_min_pnl10: '최소 %PNL 10 %',
            txt_min_pnl0: '최소 %PNL 0 %',

            txt_no_min_required: '최소 %PNL이 필요하지 않습니다',
            txt_rules_title: '규칙 및 규정',
            txt_rules_1:
                '1. Season Bull/Bear는 사용자가 거래 전략을 연습 할 수있는 베타 시즌입니다.',
            txt_rules_2:
                '2. 시장에서 이용할 수있는 모든 코인을 구매/오래 판매/짧게 판매 할 수있는 100,000USD의 초기 크레딧으로 부여됩니다. 금액은 신용 잔액에서 공제됩니다. 예는 다음과 같습니다.',
            txt_rules_3:
                '3. 15 분마다 %PNL이 업데이트되어 순위에 영향을 미칩니다.',
            txt_rules_4:
                '4. 1 번의 성공적인 거래를 한 후 24 시간 이내에 순위가 수여됩니다.',
            txt_rules_5:
                '5. 청동,은, 금, 다이아몬드, 마스터 및 그랜드 마스터 및 기타 경쟁 업체의 %PNL과 같은 6 개의 다른 계급이 있습니다. 순위 기준이 표시됩니다.',
            txt_rules_6:
                '6. Bitazza는 언제든지이 이벤트의 규칙과 규정을 변경할 권리를 보유합니다.',
            txt_rules_exa_buy_title: '구매/긴 예',
            tx_r_b_des1:
                '당신은 $ 30,000에 1 btc를 구매/장거리입니다. 자산이 표시됩니다',
            tx_r_b_des2: '1 BTC (30,000USD의 가치)',
            tx_r_b_des3: '총 PNL = 0',
            tx_r_b_des4: '나머지 신용 : $ 70,000 (초기 $ 100,000)',
            tx_r_b_des5:
                'BTC의 가격이 35,000 달러로 상승하면 자산이 이제 반영됩니다.',
            tx_r_b_des6: 'PNL = 5,000USD (35,000-30,000)',
            txt_rules_exa_sell_title: '판매/짧은 예',
            tx_r_s_des1:
                '$ 30,000에 1 BTC를 판매/짧게합니다. 자산이 표시됩니다',
            tx_r_s_des2: '나머지 신용 : $ 70,000 (초기 $ 100,000)',
            tx_r_s_des3:
                'BTC의 가격이 25,000 달러로 하락하면 자산이 이제 반영됩니다.',
            text_here: '여기',
            txt_overall_pnl: '전체 %PNL',
            txt_higher_than_users: '사용자의 %보다 높습니다',

            txt_no_rewards_this_season: '*이 베타 시즌에는 보상이 없습니다',
            txt_view_season_summary: '시즌을보기 위험이없는 요약',

            txt_view: '보기',
            txt_summary: '요약',
            txt_claim_nft: 'Claim NFT Reward',
            text_share: 'Share',
            txt_n_of: '아니요. 의',
            txt_challenger: '도전자',
            txt_average: '평균',
            txt_top_challengers: '최고의 도전자',
            txt_joining_fee: '가입 수수료',
            txt_limited_time: '* 제한된 시간. 지금 가입하세요!',
            txt_free: '무료',
            txt_join_btn: '거래 시뮬레이터에 가입하십시오',
            txt_calc_rewards: '보상 계산',
            txt_calc_rewards_des:
                '보상이 계산되고 있으며 2 시간 이하가 걸립니다.',
            txt_prize_pool: '상금 풀 할당',
            txt_prize_allocation: '상금 수영장 할당',
            txt_btz_awarded: 'BTZ 금액 수여',
            txt_usdt_awarded: 'FDS 금액 수여',

            txt_profile_Special: '특수 문자를 사용하지 마십시오.',
            txt_profile_char: '프로필 이름은 2-8 자 사이여야합니다.',
            txt_profile_impolite: '무례하거나 불예의 단어를 사용하지 마십시오.',
            txt_wins_refers:
                "트레이딩 시뮬레이터에서 '승리'는 포트폴리오의 전체 가치에서 이익이 발생하는 날을 의미합니다.",
            txt_your_ranking:
                '가장 긴 연속 승리는 포트폴리오의 전체 가치에서 이익이 발생한 연속일 중 가장 높은 수를 추적하는 지표입니다.',
            txt_join_later: '순위를 위한 임계 날짜보다 늦게 가입했습니다',
            txt_max_50: '최대 50명의 도전자',
            txt_days: '일',
            txt_hours: '시간',
            txt_minutes: '분',
            txt_sec: ' 초',

            txt_below_avr: '평균 이하',
            txt_higher_than: '~보다 높음',
            txt_of_users: '사용자의',
            txt_of_trader: '트레이더의',
            txt_of_bronze: '청동 배지를 가진 사용자의',
            txt_badge_note: '주의: 배지는 GMT+7 00.00에 매일 업데이트됩니다.',
            txt_more_trade_1: '만들어야 합니다',
            txt_more_trade_2:
                '리더보드 안에 자격을 얻기 위해 더 많은 거래를 해야 합니다.',
            txt_more_trade_3:
                '리더보드 안에 자격을 얻기 위해 더 많은 거래를 해야 합니다.',
            text_total_prize: '총 상금 풀',
            txt_max_prize_pool: '최대 상금 풀',
            txt_prize_pool_des: '도전자 수에 따라 상금이 증가합니다',
            txt_prize_pool_view: '상금 배분 보기',
        },
    },

    pt: {
        translation: {
            txt_top100: 'TOP 100',
            txt_my_ranking: 'O MEU RANKING',
            txt_rank: 'Ranking',
            txt_name: 'Nome',
            txt_search_challenger: 'Procurar Desafiante',
            txt_no_result: 'Sem resultados',
            txt_performance: 'Desempenho',
            txt_statistics: 'ESTATÍSTICAS',
            txt_performance_des:
                'O desempenho estará disponível 24 horas após a realização de uma operação.',
            txt_statistics_des: 'ESTATISTICAS',
            txt_cumulative_prf: 'DESEMPENHO CUMULATIVO',

            txt_all_time: 'Todo o tempo',
            text_index: 'índice',
            txt_performance_index_title: 'O que é Índice de Desempenho?',
            txt_performance_index_des_1:
                'No Simulador de Trading Bitazza, o Índice de Desempenho padroniza o tamanho do portfólio de cada usuário para uma linha de base de 10. Esta normalização garante uma comparação equitativa, especialmente quando os usuários têm tamanhos iniciais de portfólio variáveis.',
            txt_close: 'fechar',
            txt_longest: 'Mais longo',
            txt_winning_streak: 'sequência de vitórias',
            txt_highest_daily: 'Ganho diário mais alto',
            txt_gain: 'volume',
            txt_volume: 'Volume',
            txt_volume_traded: 'Número de operações na',
            txt_this_week: 'esta semana',
            txt_n_trades_last_week: 'Número de operações da semana passada',
            txt_n_trades_last_month: 'Número de operações do mês passado',

            txt_v_crypto_last_week:
                'Variedade de criptomoedas negociadas na semana passada',
            txt_v_crypto_last_month:
                'Variedade de criptomoedas negociadas no mês passado',
            txt_h_v__trade_last_week:
                'Moeda com maior volume de transações na semana passada',
            txt_h_v__trade_last_month:
                'Moeda com maior volume de transações no mês passado',
            txt_max_exposure_last_week:
                'Exposição máxima ao ativo na semana passada',
            txt_max_exposure_title: 'Exposição máxima a um ativo',
            txt_max_exposure_des1:
                'A exposição máxima a um ativo é uma métrica crucial para investidores que denota a maior percentagem de um ativo específico detido numa carteira. Por exemplo, se um investidor detém 50% em BTC, 30% em ETH, e 20% em USDS, a sua máxima exposição ao ativo seria de 50%. Todos os ativos negativos também serão levados em conta, tomando o valor absoluto. O cálculo desta métrica baseia-se em instantâneos diários da carteira, tirados todas as noites à meia-noite às 00.00 GMT+7.',
            txt_risk_last_week: 'Risco na semana passada',
            txt_risk_title: 'Risco Ativo',
            txt_risk_des1:
                'O Risk-On é uma métrica que mede a disposição de um investidor de assumir o risco, com uma porcentagem maior indicando uma maior tolerância ao risco. A fórmula para o cálculo do risco envolve subtrair o valor dos estábulos no portfólio do tamanho total do portfólio e, em seguida, dividir o resultado pelo tamanho total do portfólio. Matematicamente, a fórmula para risco é expressa da seguinte maneira:',
            txt_risk_des2: 'Risco -on = 1 - Crédito restante / crédito inicial',
            txt_risk_des3:
                'Ao quantificar o grau de risco que um investidor está disposto a realizar, o risco pode informar as decisões de investimento e ajudar no gerenciamento de portfólio. Como em qualquer estratégia de investimento, o risco deve ser abordado criteriosamente, equilibrando o potencial de retornos mais altos com o potencial de maior volatilidade e perdas.',
            txt_risk_monthly: 'Risco mensalmente',
            txt_average_n_t_per_week: 'Número médio de negociações por semana',
            txt_average_n_t_per_month:
                'Número médio de negociações no mês passado',
            txt_v_crypto_per_week:
                'Variedade média de criptos negociados por semana',

            txt_v_crypto_per_month:
                'Variedade média de criptos negociados por mês',
            txt_edit_name: 'Edite o nome do perfil',
            txt_profile_name: 'Nome do perfil',
            txt_profile_name_des:
                'O nome do perfil só pode ser alterado uma vez',
            txt_save: 'salvar',
            txt_cancel: 'cancelar',
            txt_trading_simulator: 'Simulador de negociação',
            txt_season: 'TEMPORADA',
            txt_start_in: 'COMEÇAR',
            txt_start_des:
                'Fique atento e esteja preparado para as recompensas aguardam',
            txt_rank_tier: 'Classificação de classificação',
            txt_rules: 'REGRAS',
            txt_top_1_challengers: 'Top 3% dos desafiantes',
            txt_top_10_challengers: 'Top 10% dos desafiantes',
            txt_top_25_challengers: 'Top 25% dos desafiantes',
            txt_top_50_challengers: 'Top 50% dos desafiantes',
            txt_top_75_challengers: 'Top 75% dos desafiantes',
            txt_min_pnl30: 'PNL mínimo de 30 %',
            txt_min_pnl20: 'PNL mínimo de 20 %',
            txt_min_pnl10: 'PNL mínimo de 10 %',
            txt_min_pnl0: 'PNL mínimo de 0 %',

            txt_no_min_required: 'Sem %de pnl mínimo necessário',
            txt_rules_title: 'REGRAS E REGULAMENTOS',
            txt_rules_1:
                '1. Temporada Bull/Bear é uma temporada beta em que os usuários podem praticar suas estratégias de negociação.',
            txt_rules_2:
                '2. Você recebe com um crédito inicial de 100.000USDS, onde pode comprar/longo e vender/curtas qualquer moeda disponível no mercado. O valor será deduzido do seu saldo de crédito. Exemplos são mostrados abaixo.',
            txt_rules_3:
                '3. A cada 15 minutos, seu %PNL será atualizado, o que afeta sua classificação.',
            txt_rules_4:
                '4. Você receberá uma classificação dentro de 24 horas depois de fazer 1 comércio bem -sucedido.',
            txt_rules_5:
                '5. Há 6 fileiras diferentes: bronze, prata, ouro, diamante, mestre e grão -mestre, dependendo do seu %PNL e de outros concorrentes. Os critérios de classificação são exibidos.',
            txt_rules_6:
                '6. A Bitazza se reserva o direito de alterar as regras e regulamentos deste evento a qualquer momento.',
            txt_rules_exa_buy_title: 'Buy/Long Exemplo',
            tx_r_b_des1:
                'Você compra/Long 1 BTC a US $ 30.000. Seus ativos mostram',
            tx_r_b_des2: '1 BTC (no valor de 30.000USDS)',
            tx_r_b_des3: 'PNL total = 0',
            tx_r_b_des4: 'Crédito restante: US $ 70.000 (de US $ 100.000)',
            tx_r_b_des5:
                'Se o preço do BTC aumentar para US $ 35.000, seus ativos agora refletem',
            tx_r_b_des6: 'PNL = 5.000USDS (35.000 - 30.000)',
            txt_rules_exa_sell_title: 'Venda/exemplo curto',
            tx_r_s_des1:
                'Você vende/curto 1 BTC a US $ 30.000. Seu ativo mostra',
            tx_r_s_des2: 'Crédito restante: US $ 70.000 (de US $ 100.000)',
            tx_r_s_des3:
                'Se o preço do BTC diminuir para US $ 25.000, seus ativos agora refletem',
            text_here: 'aqui',
            txt_overall_pnl: '% %Pnl',
            txt_higher_than_users: 'Superior a % dos usuários',

            txt_no_rewards_this_season:
                '* Não há recompensas para esta temporada beta',
            txt_view_season_summary: 'Ver estação sem risco Resumo',
            txt_view: 'Ver',
            txt_summary: 'Resumo',
            txt_claim_nft: 'Claim NFT Reward',
            text_share: 'Share',
            txt_n_of: 'NÃO. DE',
            txt_challenger: 'DESAFIADOR',
            txt_average: 'MÉDIA',
            txt_top_challengers: 'Os melhores desafiantes',
            txt_joining_fee: 'Ingressar na taxa',
            txt_limited_time: '* Tempo limitado. Entrar!',
            txt_free: 'LIVRE',
            txt_join_btn: 'Junte -se ao simulador de negociação',
            txt_calc_rewards: 'Cálculo de recompensas',
            txt_calc_rewards_des:
                'Suas recompensas estão sendo calculadas, isso deve levar menos de 2 horas.',
            txt_prize_pool: 'Alocação de pool de prêmios',
            txt_prize_allocation: '% De alocação de pool de prêmios',
            txt_btz_awarded: 'Montante BTZ concedido',
            txt_usdt_awarded: 'Valor do FDS concedido',

            txt_profile_Special: 'Por favor, não use caracteres especiais.',
            txt_profile_char: 'O nome do perfil deve ter entre 2-8 caracteres.',
            txt_profile_impolite:
                'Por favor, não use palavras rudes ou impolitas.',
            txt_wins_refers:
                "No Simulador de Trading, uma 'vitória' refere-se a um dia em que é feito um ganho no valor global do portfólio.",
            txt_your_ranking:
                'A maior série de vitórias é uma métrica que acompanha o maior número de dias consecutivos em que foram feitas ganhos no valor total do portfólio.',
            txt_join_later:
                'juntou-se após a data limite para uma classificação',
            txt_max_50: 'Máximo de 50 desafiantes',
            txt_days: 'dias',
            txt_hours: 'horas',
            txt_minutes: 'minutos',
            txt_sec: ' segundos',

            txt_below_avr: 'Abaixo da média',
            txt_higher_than: 'Mais alto que',
            txt_of_users: 'de usuários',
            txt_of_trader: 'de comerciantes',
            txt_of_bronze: 'de utilizadores com um crachá de Bronze',
            txt_badge_note:
                'Nota: As insígnias são atualizadas diariamente às 00.00 GMT+7',
            txt_more_trade_1: 'Precisas de fazer',
            txt_more_trade_2:
                'mais negociações para ser elegível no quadro de líderes',
            txt_more_trade_3:
                'mais negociações para ser elegível no quadro de líderes',
            text_total_prize: 'PRÉMIO TOTAL',
            txt_max_prize_pool: 'PRÉMIO MÁXIMO',
            txt_prize_pool_des: 'O prémio aumenta com o número de desafiantes',
            txt_prize_pool_view: 'Ver a distribuição do prémio',
        },
    },
    vn: {
        translation: {
            txt_top100: 'TOP 100',
            txt_my_ranking: 'XẾP HẠNG CỦA TÔI',
            txt_rank: 'Xếp hạng',
            txt_name: 'Tên',
            txt_search_challenger: 'Tìm Kiếm Đối Thủ',
            txt_no_result: 'Không tìm thấy kết quả',
            txt_performance: 'Hiệu suất',
            txt_statistics: 'THỐNG KÊ',
            txt_performance_des:
                'Hiệu suất sẽ có sẵn trong 24 giờ sau khi thực hiện một giao dịch.',
            txt_statistics_des: 'SỐ LIỆU THỐNG KÊ',
            txt_cumulative_prf: 'HIỆU SUẤT TÍCH LŨY',

            txt_all_time: 'Mọi lúc',
            text_index: 'chỉ số',
            txt_performance_index_title: 'Chỉ số hiệu suất là gì?',
            txt_performance_index_des_1:
                'Trong Trình mô phỏng giao dịch Bitazza, Chỉ số hiệu suất chuẩn hóa quy mô danh mục đầu tư của mỗi người dùng về mức cơ bản là 10. Việc chuẩn hóa này đảm bảo so sánh công bằng, đặc biệt khi người dùng có quy mô danh mục đầu tư ban đầu khác nhau.',
            txt_close: 'đóng',
            txt_longest: 'Dài nhất',
            txt_winning_streak: 'chuỗi chiến thắng',
            txt_highest_daily: 'Lợi nhuận hàng ngày cao nhất',
            txt_gain: 'khối lượng',
            txt_volume: 'lượng',
            txt_volume_traded: 'Số lần giao dịch',
            txt_this_week: 'tuần này',
            txt_n_trades_last_week: 'Số giao dịch tuần trước',
            txt_n_trades_last_month: 'Số giao dịch tháng trước',

            txt_v_crypto_last_week:
                'Sự đa dạng của tiền điện tử được giao dịch tuần trước',
            txt_v_crypto_last_month:
                'Sự đa dạng của tiền điện tử được giao dịch tháng trước',
            txt_h_v__trade_last_week:
                'Đồng tiền được giao dịch với khối lượng lớn nhất tuần trước',
            txt_h_v__trade_last_month:
                'Đồng tiền được giao dịch với khối lượng lớn nhất tháng trước',
            txt_max_exposure_last_week:
                'Tối đa tiếp xúc với tài sản tuần trước',
            txt_max_exposure_title: 'Tiềm năng tiế exposição máxima a um ativo',
            txt_max_exposure_des1:
                'Tiếp xúc tối đa với tài sản là một số liệu quan trọng đối với các nhà đầu tư biểu thị tỷ lệ cao nhất của một tài sản cụ thể được nắm giữ trong danh mục đầu tư. Chẳng hạn, nếu một nhà đầu tư nắm giữ 50% tại BTC, 30% ở ETH và 20% ở USD, thì mức độ tiếp xúc tối đa của họ với tài sản sẽ là 50%. Tất cả các tài sản tiêu cực cũng sẽ được tính đến bằng cách sử dụng giá trị tuyệt đối. Việc tính toán số liệu này dựa trên ảnh chụp nhanh hàng ngày của danh mục đầu tư, được thực hiện mỗi nửa đêm vào lúc 00.00 GMT+7.',
            txt_risk_last_week: 'Rủi ro tuần trước',
            txt_risk_title: 'Chấp nhận rủi ro',
            txt_risk_des1:
                'Rủi ro là một số liệu đo lường sự sẵn sàng rủi ro của nhà đầu tư, với tỷ lệ phần trăm cao hơn cho thấy khả năng chịu rủi ro cao hơn. Công thức tính toán rủi ro liên quan đến việc trừ đi giá trị của stableCoin trong danh mục đầu tư từ tổng kích thước danh mục đầu tư, và sau đó chia kết quả cho tổng kích thước danh mục đầu tư. Về mặt toán học, công thức cho rủi ro được thể hiện như sau:',
            txt_risk_des2: 'Rủi ro = 1 - Tín dụng / Tín dụng ban đầu còn lại',
            txt_risk_des3:
                'Bằng cách định lượng mức độ rủi ro mà một nhà đầu tư sẵn sàng thực hiện, rủi ro có thể thông báo các quyết định đầu tư và hỗ trợ trong quản lý danh mục đầu tư. Như với bất kỳ chiến lược đầu tư nào, rủi ro phải được tiếp cận một cách thận trọng, cân bằng khả năng lợi nhuận cao hơn với tiềm năng biến động và tổn thất lớn hơn.',
            txt_risk_monthly: 'Rủi ro trên hàng tháng',
            txt_average_n_t_per_week: 'Số lượng giao dịch trung bình mỗi tuần',
            txt_average_n_t_per_month:
                'Số lượng giao dịch trung bình vào tháng trước',
            txt_v_crypto_per_week:
                'Nhiều loại tiền điện tử được giao dịch mỗi tuần',

            txt_v_crypto_per_month:
                'Nhiều loại tiền điện tử được giao dịch mỗi tháng',
            txt_edit_name: 'Chỉnh sửa tên hồ sơ',
            txt_profile_name: 'Tên hồ sơ',
            txt_profile_name_des: 'Tên hồ sơ chỉ có thể được thay đổi một lần',
            txt_save: 'cứu',
            txt_cancel: 'Hủy bỏ',
            txt_trading_simulator: 'Trading Simulator',
            txt_season: 'MÙA',
            txt_start_in: 'BẮT ĐẦU VÀO',
            txt_start_des:
                'Hãy theo dõi và chuẩn bị các phần thưởng đang chờ đợi',
            txt_rank_tier: 'Xếp hạng tầng',
            txt_rules: 'QUY TẮC',
            txt_top_1_challengers: 'Top 3% người thách thức',
            txt_top_10_challengers: 'Top 10% người thách thức',
            txt_top_25_challengers: 'Top 25% người thách thức',
            txt_top_50_challengers: 'Top 50% người thách thức',
            txt_top_75_challengers: 'Top 75% người thách thức',
            txt_min_pnl30: 'Tối thiểu %PNL 30 %',
            txt_min_pnl20: 'Tối thiểu %PNL 20 %',
            txt_min_pnl10: 'Tối thiểu %PNL 10 %',
            txt_min_pnl0: 'Tối thiểu %PNL 0 %',

            txt_no_min_required: 'Không yêu cầu %PNL tối thiểu',
            txt_rules_title: 'CÁC QUY TẮC VÀ QUY ĐỊNH',
            txt_rules_1:
                '1. Season Bull/Bear là một mùa Beta, nơi người dùng có thể thực hành các chiến lược giao dịch của họ.',
            txt_rules_2:
                '2. Bạn được cấp với khoản tín dụng ban đầu là 100.000USD, nơi bạn có thể mua/dài và bán/ngắn bất kỳ đồng tiền nào có sẵn trên thị trường. Số tiền sẽ được khấu trừ từ số dư tín dụng của bạn. Ví dụ được hiển thị dưới đây.',
            txt_rules_3:
                '3. Cứ sau 15 phút, %PNL của bạn sẽ được cập nhật ảnh hưởng đến thứ hạng của bạn.',
            txt_rules_4:
                '4. Bạn sẽ được trao cấp bậc trong vòng 24 giờ sau khi bạn thực hiện 1 giao dịch thành công.',
            txt_rules_5:
                '5. Có 6 cấp bậc khác nhau: Đồng, Bạc, Vàng, Kim cương, Master và Grand Master tùy thuộc vào đối thủ cạnh tranh của bạn và các đối thủ cạnh tranh khác %PNL. Tiêu chí xếp hạng được hiển thị.',
            txt_rules_6:
                '6. Bitazza có quyền thay đổi các quy tắc và quy định của sự kiện này bất cứ lúc nào.',
            txt_rules_exa_buy_title: 'Mua/ví dụ dài',
            tx_r_b_des1:
                'Bạn mua/dài 1 BTC ở mức 30.000 đô la. Tài sản của bạn cho thấy',
            tx_r_b_des2: '1 BTC (trị giá 30.000USD)',
            tx_r_b_des3: 'Tổng số PNL = 0',
            tx_r_b_des4:
                'Tín dụng còn lại: 70.000 đô la (từ 100.000 đô la ban đầu)',
            tx_r_b_des5:
                'Nếu giá của BTC tăng lên 35.000 đô la, thì tài sản của bạn bây giờ sẽ phản ánh',
            tx_r_b_des6: 'PNL = 5.000USD (35.000 - 30.000)',
            txt_rules_exa_sell_title: 'Bán/ví dụ ngắn',
            tx_r_s_des1:
                'Bạn bán/ngắn 1 BTC với giá 30.000 đô la. Tài sản của bạn cho thấy',
            tx_r_s_des2:
                'Tín dụng còn lại: 70.000 đô la (từ 100.000 đô la ban đầu)',
            tx_r_s_des3:
                'Nếu giá của BTC giảm xuống còn 25.000 đô la, thì tài sản của bạn bây giờ sẽ phản ánh',
            text_here: 'đây',
            txt_overall_pnl: 'Tổng thể %PNL',
            txt_higher_than_users: 'Cao hơn % người dùng',

            txt_no_rewards_this_season:
                '* Không có phần thưởng cho mùa beta này',
            txt_view_season_summary: 'Xem Tóm tắt mùa không có rủi ro',
            txt_view: 'Xem',
            txt_summary: 'Tóm tắt',
            txt_claim_nft: 'Claim NFT Reward',
            text_share: 'Share',

            txt_n_of: 'KHÔNG. CỦA',
            txt_challenger: 'Người thách thức',
            txt_average: 'TRUNG BÌNH',
            txt_top_challengers: 'Những người thách thức hàng đầu',
            txt_joining_fee: 'Tham gia phí',
            txt_limited_time: '* Thời gian giới hạn. Tham gia ngay!',
            txt_free: 'MIỄN PHÍ',
            txt_join_btn: 'Tham gia Trading Simulator',
            txt_calc_rewards: 'Tính toán phần thưởng',
            txt_calc_rewards_des:
                'Phần thưởng của bạn đang được tính toán, điều này sẽ mất ít hơn 2 giờ.',
            txt_prize_pool: 'Phân bổ giải thưởng',
            txt_prize_allocation: '% Phân bổ nhóm giải thưởng',
            txt_btz_awarded: 'Số tiền BTZ được trao',
            txt_usdt_awarded: 'Số tiền FDS được trao',

            txt_profile_Special: 'Vui lòng không sử dụng ký tự đặc biệt.',
            txt_profile_char: 'Tên hồ sơ phải từ 2 đến 8 ký tự.',
            txt_profile_impolite:
                'Vui lòng không sử dụng từ ngữ thô tục hoặc không lịch sự.',
            txt_wins_refers:
                "Trong Trading Simulator, một 'chiến thắng' ám chỉ một ngày có lợi nhuận được tạo ra trong tổng giá trị của danh mục đầu tư.",
            txt_your_ranking:
                'Chuỗi chiến thắng dài nhất là một chỉ số theo dõi số ngày liên tiếp cao nhất mà đã có lợi nhuận được tạo ra trong tổng giá trị của danh mục đầu tư.',
            txt_join_later: 'gia nhập sau ngày quy định cho một xếp hạng',
            txt_max_50: 'Tối đa 50 thử thách',
            txt_days: 'ngày',
            txt_hours: 'giờ',
            txt_minutes: 'phút',
            txt_sec: ' giây',

            txt_below_avr: 'Dưới mức trung bình',
            txt_higher_than: 'Cao hơn',
            txt_of_users: 'của người dùng',
            txt_of_trader: 'của những người giao dịchs',
            txt_of_bronze: 'của người dùng có huy hiệu Đồng',
            txt_badge_note:
                'Lưu ý: Huy hiệu được cập nhật hàng ngày lúc 00.00 GMT+7',
            txt_more_trade_1: 'Bạn cần phải thực hiện',
            txt_more_trade_2:
                'Thêm giao dịch để có điều kiện nằm trong bảng xếp hạng',
            txt_more_trade_3:
                'Thêm giao dịch để có điều kiện nằm trong bảng xếp hạng',
            text_total_prize: 'Tổng giải thưởng',
            txt_max_prize_pool: 'Giải thưởng tối đa',
            txt_prize_pool_des: 'Giải thưởng tăng theo số lượng thách thức',
            txt_prize_pool_view: 'Xem cách phân bổ giải thưởng',
        },
    },
}
